export default {"src":"/_next/static/media/FE.6e7a070f.svg","height":18,"width":18};